import { get } from '@/lib/api';

export const getWorkflowLogExecutionContext = ({ workflowLogId, cancelRef }, callback) => {
  return get(`v1/monitoring/workflow-logs/${encodeURIComponent(workflowLogId)}/context`, {
    action: 'GET_WORKFLOW_LOG_EXECUTION_CONTEXT',
    loader: `getWorkflowLogExecutionContext-${workflowLogId}`,
    callback,
    cancelRef,
    meta: { workflowLogId }
  });
};
